import { createSelector } from 'reselect';

const authStateSelector = (state) => state.auth;

// user
export const authCurrentUserSelector = createSelector(
  [authStateSelector],
  (auth) => auth.user
);

// profiles

export const authUserProfilesSelector = createSelector(
  [authStateSelector],
  (auth) => auth.profiles
);

export const artisanDataSelector = createSelector(
  [authUserProfilesSelector],
  (profiles) => profiles?.artisanData
);

export const supplierDataSelector = createSelector(
  [authUserProfilesSelector],
  (profiles) => profiles?.supplierData
);
export const customerDataSelector = createSelector(
  [authUserProfilesSelector],
  (profiles) => profiles?.customerData
);
export const applicantDataSelector = createSelector(
  [authUserProfilesSelector],
  (profiles) => profiles?.applicantData
);

export const authUserIdSelector = createSelector(
  [authCurrentUserSelector],
  (user) => user._id
);

export const authTokenSelector = createSelector(
  [authStateSelector],
  (auth) => auth.token
);

export const authCurrentUserTypeSelector = createSelector(
  [authCurrentUserSelector],
  (user) => {
    if (user) return user.userType;
    return [];
  }
);

export const authCurrentDefaultTypeSelecetor = createSelector(
  [authCurrentUserSelector],
  (user) => user.defaultUserType
)

export const authCurrentUserSettings = createSelector(
  [authCurrentUserSelector],
  (user) => ({
    settingsReceiveNotifications: user.settingsReceiveNotifications,
    settingsDefaultCurrency: user.settingsDefaultCurrency,
    settingsUILanguage: user.settingsUILanguage,
    settingsDefaultCountry: user.settingsDefaultCountry,
  })
);

// Misc
export const authIsLoadingSelector = createSelector(
  [authStateSelector],
  (auth) => auth.isLoading
);
